import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Edit, Trash2 } from "react-feather";
import Swal from "sweetalert2";
import { baseurl } from "../../component/Baseurl";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";

function BookingEnquiry() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Fetch booking data
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await axios.get(`${baseurl}/GetAllBookings`);
        setBookings(response.data.bookings);
      } catch (err) {
        setError("Error fetching bookings. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  }, []);

  // Redirect to Edit Booking Page
  const handleEdit = (id) => {
    navigate(`/admin/edit-booking/${id}`);
  };

  // Delete Booking Function
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}DeleteBookingById/${id}`);

          // Remove the deleted booking from state
          setBookings((prevBookings) => prevBookings.filter((b) => b.id !== id));

          Swal.fire("Deleted!", "Booking has been deleted.", "success");
        } catch (err) {
          Swal.fire("Error!", "Failed to delete booking. Try again.", "error");
        }
      }
    });
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <BreadCrumb />
          <div className="container-fluid">
            <div className="crdmain mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="chart-title text-start">Booking Enquiry</h2>
              </div>

              {/* Show Loading or Error Message */}
              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : (
                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
                    <div className="table-responsive classic-table">
                      <table className="table table-striped table-hover">
                        <thead className="table-header">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Departure Date</th>
                            <th>Return Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookings.map((booking, index) => (
                            <tr key={booking.id}>
                              <td>{index + 1}</td>
                              <td>{booking.name}</td>
                              <td>{booking.phone}</td>
                              <td>{booking.email}</td>
                              <td>{new Date(booking.departure_date).toLocaleDateString()}</td>
                              <td>{new Date(booking.return_date).toLocaleDateString()}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    booking.status === "Active"
                                      ? "bg-success"
                                      : booking.status === "Pending"
                                      ? "bg-warning"
                                      : "bg-danger"
                                  }`}
                                >
                                  {booking.status}
                                </span>
                              </td>
                              <td>
                                <span
                                  className="btn2 me-2"
                                  title="Edit"
                                  onClick={() => handleEdit(booking.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <Edit size={15} />
                                </span>
                                <span
                                  className="btn2 text-danger"
                                  title="Delete"
                                  onClick={() => handleDelete(booking.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <Trash2 size={15} />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BookingEnquiry;
